"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBDMenuOption = void 0;
class FBDMenuOption {
    constructor(text, description, selectable = false, callback = null, back_callback = null) {
        this.text = text ? text.toUpperCase() : "";
        this.description = description ? description.toUpperCase() : "";
        this.selectable = selectable;
        this.callback = callback;
        this.back_callback = back_callback;
        this.idx = -1;
    }
    updateText(gray = false) {
        if (this.option) {
            this.option.update_text(this.text);
        }
    }
}
exports.FBDMenuOption = FBDMenuOption;
